export default __webpack_public_path__ + "static/media/07.819e2d4f.svg";